import Indicator, { IndicatorType } from '../types/Indicator'

const KeltnerChannel: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'keltnerChannel',
  label: 'Keltner Channel',
  nickname: 'Keltner Channel',
  fields: ['upper', 'middle', 'lower'],
  params: {
    period: 20,
    multiplier: 5,
  },
}

export default KeltnerChannel
